import { render } from "./RingCentralCMS.vue?vue&type=template&id=013cdae9&scoped=true"
import script from "./RingCentralCMS.vue?vue&type=script&lang=js"
export * from "./RingCentralCMS.vue?vue&type=script&lang=js"

import "./RingCentralCMS.vue?vue&type=style&index=0&id=013cdae9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013cdae9"]])

export default __exports__